import { Grid, Typography } from "@mui/material";

import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ProducersComponetInversor from "./ProducersComponetInversor";
import { Inverters, Producer } from "../types";
import TextInput from "../../../main/components/TextInput";
import { useEffect } from "react";

const schema = yup.object({
  amount: yup.number().required("Campo obrigatório"),
  inverterPower: yup.number().required("Campo obrigatório"),
  firstInverterNumber: yup.number().required("Campo obrigatório"),
});

// Defina o tipo para o Resolver
type MyResolver = Resolver<Inverters, yup.InferType<typeof schema>>;

interface EditInvertersUsinaProps {
  uG: {
    components?: {
      inverters?: {
        amount?: number;
        inverterPower?: number;
        firstInverterNumber?: number;
        producers: Producer[];
      };
    };
  };
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;

  // handleProducersChange: (
  //   objectName: keyof Components,
  //   updatedProducers: Producer[]
  // ) => void;
  updateStateContent: (
    field: string,
    objectName: string,
    value?: number | string | string[] | Producer[]
  ) => void;
}

const EditInvertersUsina: React.FC<EditInvertersUsinaProps> = ({
  uG,
  isEditing,
  setIsEditing,
  // handleProducersChange,

  updateStateContent,
}) => {
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
    watch,
  } = useForm<Inverters>({
    defaultValues: {
      amount: uG?.components?.inverters?.amount || 0,
      inverterPower: uG?.components?.inverters?.inverterPower || 0,
      firstInverterNumber: uG?.components?.inverters?.firstInverterNumber || 0,
      producers: uG?.components?.inverters?.producers || [],
    },
    resolver: yupResolver(schema) as MyResolver,
  });

  type InvertersField = keyof Inverters;

  // Função para converter o valor de string para número e enviar para o pai
  const handleInvertersValueChange = (field: InvertersField, value: string) => {
    const numericValue = value === "" ? undefined : Number(value);
    setValue(field, numericValue);
  };

  //Atualiza os producers
  const handleProducers = (updatedProducers: Producer[]) => {
    console.log("Dados atualizados de produtores recebidos:", updatedProducers);
    updateStateContent("producers", "inverters", updatedProducers);
  };

  const onSubmit: SubmitHandler<Inverters> = async (data) => {
    console.log("onSubmit acionado no filho INVER:", data);

    // Use a função handleInverterValueChange para manipular a mudança de campo
    handleInvertersValueChange("amount", String(data.amount));
    handleInvertersValueChange("inverterPower", String(data.inverterPower));
    handleInvertersValueChange("firstInverterNumber", String(data.firstInverterNumber));

    const producersValue: Producer[] = data.producers || [];

    // array de produtores do estado, tratando 'undefined' como um array vazio
    const existingProducers: Producer[] =
      uG?.components?.inverters?.producers || [];

    // Atualize o estado no componente pai, condicionalmente
    if (uG?.components?.inverters?.amount !== data.amount) {
      updateStateContent("amount", "inverters", data.amount);
    }
    if (uG?.components?.inverters?.inverterPower !== data.inverterPower) {
      updateStateContent("inverterPower", "inverters", data.inverterPower);
    }
    if (uG?.components?.inverters?.firstInverterNumber !== data.firstInverterNumber) {
      updateStateContent("firstInverterNumber", "inverters", data.firstInverterNumber);
    }

    // Converta a quantidade de produtores para um formato aceitável pela função
    const producersValueCount: number = producersValue.length;

    // Atualize o estado no componente pai, condicionalmente
    if (producersValueCount !== existingProducers.length) {
      updateStateContent("producers", "inverters", producersValueCount);
    }
    console.log("Formulário submetido com:", data);
  };

  const amount = watch("amount");
  const inverterPower = watch("inverterPower");
  const firstInverterNumber = watch("firstInverterNumber");

  useEffect(() => {
    console.log(
      "Atualizando amount no componente pai para:",
      getValues("amount")
    );
    updateStateContent("amount", "inverters", getValues("amount"));
  }, [amount]);

  useEffect(() => {
    console.log(
      "Atualizando inverterPower no componente pai para:",
      getValues("inverterPower")
    );
    updateStateContent(
      "inverterPower",
      "inverters",
      getValues("inverterPower")
    );
  }, [inverterPower]);

  useEffect(() => {
    console.log(
      "Atualizando firstInverterNumber no componente pai para:",
      getValues("firstInverterNumber")
    );
    updateStateContent(
      "firstInverterNumber",
      "inverters",
      getValues("firstInverterNumber")
    );
  }, [firstInverterNumber]);

  useEffect(() => {
    const producersArray = (getValues("producers") as Producer[]) || [];

    console.log(
      "Atualizando producers no componente pai para:",
      producersArray
    );

    updateStateContent("producers", "inverters", producersArray);
  }, [getValues("producers")]);

  return (
    <Grid
      container
      sx={{
        padding: "20px",
        flexDirection: "row",
        display: "flex",
        backgroundColor: "rgba(217, 217, 217, 0.1)",
        borderRadius: 2,
        marginTop: "8px",
        marginBottom: "8px",
        rowGap: "16px ",
        width: "100%",
      }}
    >
      <Grid item xs={6} textAlign={"start"}>
        <Typography>Quantidade de Inversores</Typography>
      </Grid>

      <Grid container spacing={2}>
        <Grid
          container
          spacing={2}
          sx={{ padding: "20px" }}
          onSubmit={handleSubmit(onSubmit)}
        >
          {isEditing ? (
            <>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="amount"
                  label={"N° de Inversores"}
                  errors={errors}
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="inverterPower"
                  label={"Potência Inversor"}
                  errors={errors}
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="firstInverterNumber"
                  label={"Número do Primeiro Inversor"}
                  errors={errors}
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              {/*  */}
            </>
          ) : (
            <>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="amount"
                  label={"N° de Inversores"}
                  errors={errors}
                  disabled
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="inverterPower"
                  label={"Potência Inversor"}
                  errors={errors}
                  disabled
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextInput
                  control={control}
                  fieldName="firstInverterNumber"
                  label={"Número do Primeiro Inversor"}
                  errors={errors}
                  disabled
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                />
              </Grid>
            </>
          )}
          {/* <Button type="submit" onClick={handleSaveAndExitEditMode}>
            Salvar Dados
          </Button> */}
          <ProducersComponetInversor
            producers={uG?.components?.inverters?.producers || []}
            isEditing={isEditing}
            // handleProducersChange={(updatedProducers) => {
            //   handleProducersChange("inverters", updatedProducers);
            // }}
            setIsEditing={setIsEditing}
            handleProducers={handleProducers}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditInvertersUsina;
